import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { Avatar } from "@material-tailwind/react";
import React from "react";
import { ThreeDots } from "react-loader-spinner";
import { getInitialsFromEmail } from "../../../Utils/Helper";
import WorkspaceStack from "../AvatarStack/WorkSpaceStack";
import { primaryColor } from "../../../Utils/Constant";

const WorkSpaceOptionCard = ({ picture, title, member, loading, itemId }) => {
  return (
    <div className="flex justify-between p-3 w-full ">
      <div className="grid grid-cols-[auto_1fr_auto] gap-4 w-full">
        {picture ? (
          <Avatar src={picture} alt={title} className="flex-shrink-0" />
        ) : (
          <div className="inline-flex items-center flex-shrink-0 justify-center h-12 w-12 uppercase font-bold shadow-lg border border-primary-basic text-primary bg-white  rounded-full">
            {getInitialsFromEmail(title)}
          </div>
        )}
        <div>
          <p className="text-sm text-debatePalette-title font-medium overflow-hidden line-clamp-1 max-w-[350px]">
            {title}
          </p>
          <div className="flex gap-2">
            <WorkspaceStack />
            <p>{`${member} members`}</p>
          </div>
        </div>
      </div>
      {loading === itemId ? (
        <ThreeDots height={20} width={20} color={primaryColor}/>
      ) : (
        <ArrowRightIcon className="h-6 w-6" />
      )}
    </div>
  );
};

export default WorkSpaceOptionCard;
